export default "__VITE_PUBLIC_ASSET__8cc46955__"